import * as types from '@/store/mutation-types';
import _ from 'lodash';

const getters = {
  siteTheme(state, getters, rootState) {
    return rootState.Websites.currentSite.siteTheme;
  },
};

const mutations = {
  [types.SET_SITE_THEME](state, payload) {
    payload.rootState.siteTheme = payload.theme;
  },
  [types.SET_SITE_RGBA](state, payload) {
    payload.rootState.siteBaseColor.rgba = payload.rgba;
  },
  [types.SET_SITE_PICKER](state, payload) {
    payload.rootState.siteBaseColor.picker = payload.picker;
  },
  [types.SET_FAVICON](state, p) {
    p.site.favicon = p.favicon;
  },
  [types.ADD_SITE_FONT](state, p) {
    if (!p.site.fonts.includes(p.font)) {
      p.site.fonts.push(p.font);
    }
  },
  [types.REMOVE_SITE_FONT](state, p) {
    const i = _.findIndex(p.site.fonts, f => f === p.font);
    p.site.fonts.splice(i, 1);
  },
  [types.SET_NEW_SITE_VALUES](state, p) {
    _.forEach(p.values, (item) => {
      p.vm.$set(p.site, item.key, item.value);
    });
  },
  [types.CHANGE_GLOBAL_PAGE_CSS](state, p) {
    const selector = _.find(p.site.mediaQueries, { selector: p.selector });
    const property = _.find(selector.properties, { property: p.property });
    property.desktop = p.val;
  },
  [types.CHANGE_SITE_PAGE_CSS](state, p) {
    const defaults = {
      property: p.property,
      desktop: p.val,
      tablet: 'default',
      mobile: 'default',
    };
    const selector = _.find(p.site.mediaQueries, { selector: p.selector });
    // check if selector exists
    if (selector) {
      const property = _.find(selector.properties, { property: p.property });
      // if property exists, we can safely update the value
      if (property) {
        property.desktop = p.val;
      } else {
        selector.properties.push(defaults);
      }
    } else {
      // add full selector with new property if it doesn't exist
      p.site.mediaQueries.push({
        selector: p.selector,
        properties: [defaults],
      });
    }
  },
};

const actions = {
  setSiteTheme: ({ commit, rootState }, settings) => {
    const payload = {
      theme: settings.theme,
      rootState: rootState.Websites.currentSite,
    };
    commit(types.SET_SITE_THEME, payload);
  },
  setSiteRgba: ({ commit, rootState }, color) => {
    const payload = {
      rgba: color,
      rootState: rootState.Websites.currentSite,
    };
    commit(types.SET_SITE_RGBA, payload);
  },
  setSitePicker: ({ commit, rootState }, color) => {
    const payload = {
      picker: color,
      rootState: rootState.Websites.currentSite,
    };
    commit(types.SET_SITE_PICKER, payload);
  },
  setFavicon: ({ commit, rootState }, payload) => {
    payload.site = rootState.Websites.currentSite;
    commit(types.SET_FAVICON, payload);
  },
  addSiteFont: ({ commit, rootState }, payload) => {
    commit(types.ADD_SITE_FONT, {
      site: rootState.Websites.currentSite,
      font: payload,
    });
  },
  removeSiteFont: ({ commit, rootState }, payload) => {
    commit(types.REMOVE_SITE_FONT, {
      site: rootState.Websites.currentSite,
      font: payload,
    });
  },
  setNewSiteValues: ({ commit }, payload) => {
    commit(types.SET_NEW_SITE_VALUES, payload);
  },
  changeGlobalPageCss: ({ commit }, payload) => {
    commit(types.CHANGE_GLOBAL_PAGE_CSS, payload);
  },
  changeSitePageCss: ({ commit }, payload) => {
    commit(types.CHANGE_SITE_PAGE_CSS, payload);
  },
};

export default {
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/global-options/vuex.js